<script>
import EzBadge from '@/components/ui/Badge/EzBadge';
import EzButton from '@/components/ui/Button/EzButton';

/**
 *
 * @version 1.0.0
 * @since
 */
export default {
  name: 'footerForUpdate',
  components: {
    EzBadge,
    EzButton,
  },
  props: {
    entity: {
      type: String,
      required: false,
      default: 'Products',
    },
    itemsCount: {
      type: Number,
      required: true,
      default: 0,
    },
    hasSecondaryAction: {
      type: Boolean,
      required: false,
      default: false,
    },
    secondaryActionEntity: {
      type: String,
      required: false,
      default: 'Products',
    },
    showSelectAll: {
      type: Boolean,
      required: false,
      default: false,
    },
    allSelected: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  methods: {
    onCtaClick() {
      this.$emit('footerAction');
    },
    onSecondaryCtaClick() {
      this.$emit('footerSecondaryAction');
    },
    onSelectAllClick() {
      this.$emit('selectAll', !this.allSelected);
    },
  },
  mounted() {
    document.body.classList.add('has-update-footer');
  },
  beforeDestroy() {
    document.body.classList.remove('has-update-footer');
  },
};
</script>

<template>
  <div class="footer">
    <div class="footer__container">
      <div class="selected-items">
        {{ entity }} Selected: <ez-badge type="blue" :count="itemsCount" />
      </div>
      <button
        v-if="showSelectAll"
        type="button"
        class="footer__select-all"
        @click="onSelectAllClick"
      >
        {{ allSelected ? 'Deselect All' : 'Select All' }}
      </button>
      <div class="footer__actions">
        <ez-button
          v-if="hasSecondaryAction"
          class="mr-12"
          :disabled="!itemsCount"
          @click="onSecondaryCtaClick"
        >
          Update {{ secondaryActionEntity }}
        </ez-button>
        <ez-button :disabled="!itemsCount" @click="onCtaClick">
          Update {{ entity }}
        </ez-button>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.footer {
  background-color: #ffffff;
  border-top: 1px solid $color-gray-E9;
  width: 100%;
  height: 56px;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;

  &__container {
    padding: 0 48px;
    margin: 0 auto;
    height: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  &__actions {
    display: flex;
    align-items: center;
  }
  &__select-all {
    background: transparent;
    border: none;
    padding: 0;
    color: $color-primary-blue;
    font-weight: 500;
    cursor: pointer;
    @include font-size(14px, 20px);
    &:hover { text-decoration: underline; }
  }
  .selected-items {
    color: $color-gray-6C;
    @include font-size(14px, 20px);
  }
}

@media (max-width: 1023px) {
  .footer {
    &__container {
      padding: 0 12px;
      gap: 8px;
    }
    .selected-items,
    &__select-all,
    &__actions {
      white-space: nowrap;
    }
  }
}
</style>

<style lang="scss">
@media (max-width: 1023px) {
  body.has-update-footer {
    .intercom-lightweight-app-launcher,
    .intercom-namespace .intercom-launcher,
    .intercom-launcher-frame {
      bottom: 76px !important;
    }
  }
}
</style>
